import { useEffect } from 'react'
import { ActivityIndicator } from 'react-native'

import { usePrayerSpaceV2 } from '@/src/features/prayer-space/services/usePrayerSpaceV2'
import { PrayerSpaceScreen as OldPrayerSpaceScreen } from '@/src/features/prayer-space/ui/screens/PrayerSpaceScreen/PrayerSpaceScreen'
import { PrayerSpaceScreenV2 as NewPrayerSpaceScreen } from '@/src/features/prayer-space/ui/screens/PrayerSpaceScreenV2'
import { GTM } from '@/src/general/utils/gtm'
import { EVENTS } from '@/src/general/utils/gtm/constants/Events.enum'

export const PrayerSpaceScreen = () => {
  const prayerSpaceV2 = usePrayerSpaceV2()

  const shouldShowNewPrayerSpace = prayerSpaceV2?.shouldShowNewPrayerSpace ?? null
  const userId = prayerSpaceV2?.userId ?? null
  const userBucket = prayerSpaceV2?.userBucket ?? null
  const isNewlyRegisteredUser = prayerSpaceV2?.isNewlyRegisteredUser ?? null
  const rolloutPercent = prayerSpaceV2?.rolloutPercent ?? null

  useEffect(() => {
    if (
      shouldShowNewPrayerSpace === null ||
      userBucket === null ||
      isNewlyRegisteredUser === null ||
      rolloutPercent === null
    )
      return

    GTM.sendEvent(
      { event: EVENTS.PRAYER_SPACE_VARIANT_ASSIGNED },
      {
        prayer_space_variant: shouldShowNewPrayerSpace ? 'new_prayer_space' : 'legacy_prayer_space',
        prayer_space_rollout_bucket: rolloutPercent,
        user_bucket: userBucket,
        prayer_space_user_type: isNewlyRegisteredUser ? 'newly_registered' : 'existing',
      },
      true,
    )
  }, [shouldShowNewPrayerSpace, userBucket, isNewlyRegisteredUser, rolloutPercent])

  if (shouldShowNewPrayerSpace === null || userId === null || isNewlyRegisteredUser === null)
    return <ActivityIndicator />

  return shouldShowNewPrayerSpace ? (
    <NewPrayerSpaceScreen isExistingUser={!isNewlyRegisteredUser} userId={userId} />
  ) : (
    <OldPrayerSpaceScreen />
  )
}
